import { currencyFormat } from '@/helpers/stringHelpers';

import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const OrderTenderView = ({ tender }) => {
  return (
    <Card className="py-0">
      <CardContent className="py-4">
        <div className="mb-2 flex gap-4">
          <h3>Credit Card</h3>
          <Badge variant="secondary">{tender.status}</Badge>
        </div>
        <span className="block mb-2">
          {tender.cardBrand} &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull;
          &bull;&bull;&bull;&bull; {tender.last4}
        </span>
        <span>{currencyFormat(tender.amount)}</span>
      </CardContent>
    </Card>
  );
};

export default OrderTenderView;
